import { stripDocumentSeparators } from './internal';

/** CEP canônico: 8 dígitos, sem máscara. */
export const CEP_PATTERN = /^[0-9]{8}$/;
export const CEP_LENGTH = 8;

export function canonicalizeCep(input: string): string | null {
  const stripped = stripDocumentSeparators(input);
  return CEP_PATTERN.test(stripped) ? stripped : null;
}

export function isValidCep(input: string): boolean {
  return canonicalizeCep(input) !== null;
}

/** `01310-100` para exibição, ou `null`. */
export function formatCep(input: string): string | null {
  const canonical = canonicalizeCep(input);
  if (canonical === null) return null;
  return `${canonical.slice(0, 5)}-${canonical.slice(5)}`;
}
